import { observer } from "mobx-react";
import React, { useEffect, useRef, useState } from "react";
import translationsStore from "../../stores/TranslationsStore";
import "./LanguageSwitcher.scss";

const LANGUAGES = [
  {
    lang: "en",
    title: "English",
  },
  {
    lang: "de",
    title: "Deutsch",
  },
  {
    lang: "fr",
    title: "Français",
  },
  {
    lang: "it",
    title: "Italiano",
  },
];

const LanguageSwitcher: React.FC = () => {
  const [isOpenDropdown, setIsOpenDropdown] = useState(false);
  const node = useRef<HTMLDivElement>(null);
  const changeLanguage = (lng: string) => {
    translationsStore.setSelectedLanguage(lng);
  };

  useEffect(() => {
    function handleClickOutside(e: any) {
      if (node && node.current && !node.current.contains(e.target)) {
        setIsOpenDropdown(false);
      }
    }
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  function toggleLanguageDropdown() {
    setIsOpenDropdown((value) => !value);
  }

  return (
    <div
      role="switch"
      aria-checked="true"
      ref={node}
      className={`language-switcher ${
        isOpenDropdown ? "language-switcher--state-open" : ""
      }`}
      onClick={toggleLanguageDropdown}
    >
      <p>
        <i
          className={`flag-icon flag-icon--${translationsStore.selectedLanguage}`}
        />
      </p>
      <div
        className={`language-switcher__dropdown ${
          isOpenDropdown ? "language-switcher__dropdown--state-visible" : ""
        }`}
      >
        {LANGUAGES.map(({ lang, title }) => {
          return (
            <button
              key={lang}
              type="button"
              onClick={() => changeLanguage(lang)}
              className={
                translationsStore.selectedLanguage === lang
                  ? "current-language"
                  : ""
              }
            >
              <i className={`flag-icon flag-icon--${lang}`} /> {title}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default observer(LanguageSwitcher);
